export default {
  courseOutline: {
    id: '',
    subjectCode: '',
    teacherCode: '',
    totalPoint: null,
    instruction: '',
    streamIntroPath: '',
    bookName1: '',
    bookPic1: '',
    bookDescription1: '',
    bookName2: '',
    bookPic2: '',
    bookDescription2: '',
    bookName3: '',
    bookPic3: '',
    bookDescription3: '',
    degreeId: '',
    subjectGroupId: '',
    subjectId: '',
    teacherId: '',
    courseOutlineUnits: [],
    courseOutlineAssessments: [],
    vdoSets: [],
  },
  courseOutlines: [],
  processing: false,
  error: null,
  success: null,
}



